'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = normalizeModifiers;
function normalizeModifiers(modifiers) {
  return (Array.isArray(modifiers) ? modifiers : [modifiers]).filter(function (i) {
    return typeof i === 'string' && !!i;
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-components-modifiers/dist/utils/normalizeModifiers.js
// module id = 698
// module chunks = 2